<template>
  <div class="logo">
    <router-link :to="{ name: 'Home', params: { locale: $i18n.locale } }">
      <img src="../assets/images/logo.svg" alt="logo qic travel insurance">
      <div class="logo_add" :class="[appName]" >
        <span>{{ firstLineLogo }}</span>
        <i class="logoArrow"></i>
        <span>{{ secondLineLogo }}</span>
        </div>
    </router-link>
  </div> <!-- logo -->
</template>

<script>
export default {
  name: 'RenewLogo',
  props: [
    'firstLineLogo',
    'secondLineLogo',
    'appName'
  ]
}
</script>
